// Copyright (C) 2013 Minted Inc.
// All Rights Reserved
//
// When the recently viewed flash app failed, we had to reimplement it in
// js/html/css. This had to be done quickly, and the existing recently
// viewed area in the 4-up version of the cat page couldn't quickly be reused.
// Therefore, this version exists to fill the need until we unify interfaces.
//
// See https://wiki.minted.com/index.php/Recently_Viewed

(function (M, Backbone, $, _) {
  'use strict';

  M.View = M.View || {};

  M.View.RecentlyViewedBlock = Backbone.View.extend({
    className: 'recentlyViewedBlock',
    template: M.Template.RecentlyViewed.Block,
    itemView: M.View.RecentlyViewedItem,

    initialize: function (options) {
      _.bindAll(this, 'renderItem', 'setUpCarousel');
      if (!this.$el) {
        this.$el = $(this.el);
      }
      if (options && options.type) {
        this.type = options.type;
        var typeClass = this.className +
          this.type.charAt(0).toUpperCase() + this.type.substr(1);
        this.$el.addClass(typeClass);
        if (this.type === 'large') {
          this.itemFallbackDimension = 400;
        } else {
          this.itemFallbackDimension = 200;
        }
      }
    },

    render: function () {
      this.$el.html(this.template());
      this.$itemsContainer = this.$('.itemsContainer');
      this.collection.each(this.renderItem);
      _.defer(this.setUpCarousel);
      return this;
    },

    setUpCarousel: function () {
      var config = {
        initCallback: M.carousel.buildCarouselControls,
        className: this.className,
        itemLoadCallback: {
          onBeforeAnimation: M.carousel.itemLoadCallback
        },
        buttonNextHTML: null,
        buttonPrevHTML: null,
        size: Math.ceil(this.collection.length / 4),
        wrap: 'last',
        visible: 1,
        itemFallbackDimension: this.itemFallbackDimension,
      };

      if (this.options.tracking) {
        config.tracking = {
          source: this.options.tracking.context,
          sku: this.options.tracking.sku,
          event: M.GA.TRACK_EVENT_ACTION.RECENTLY_VIEWED_PAGINATION_CLICK
        };
      }

      this.$itemsContainer.jcarousel(config);
    },

    renderItem: function (model, i) {
      if (i % 4 === 0) {
        var li = $('<li>').appendTo(this.$itemsContainer);
        this.$itemGroup = $('<div class="itemGroup">').appendTo(li);
      }

      var view = new this.itemView({
        model: model,
        tracking: this.options.tracking
      });

      this.$itemGroup.append(view.render().el);
    }
  });

})(M, Backbone, jQuery, _);

